import React, { useEffect } from 'react';
import './ToastMessage.css'

const ToastMessage = ({toastTitle, toastMessage, toastType, closeOut}) => {

    const toastIcon = toastType === 'success' ? '/assets/success_icon.svg' :
                  (toastType === 'warning' ? '/assets/warning_icon.svg' :
                  '/assets/error_icon.svg');
    useEffect(() => {
        const timer = setTimeout(() => {
            closeOut();
        }, 3000);

        return () => clearTimeout(timer);
    }, [closeOut]);

    return (
        <div className='toast-container'>
            <div className={`toast-content ${toastType}`}>
                <img src={toastIcon} alt={toastType} className='toast-icon'/>
                <div className='toast-message'>
                    <h6>{toastTitle}</h6>
                    <p>{toastMessage}</p>
                </div>
                {(toastType === 'success' || toastType === 'warning') && (
                    <img src='/assets/close_white.svg' alt='close icon' className='toast-close-icon'/>
                )}

                {/* {toastType === 'error' && (
                    <div className='toast-btn-container'>
                        <button>Try again</button>
                    </div>
                )} */}
            </div>

        </div>
    )
}

export default ToastMessage;